export const FlagsUnicode: Record<string, string> = {
  az: '🇦🇿',
  bt: '🇧🇹',
  ec: '🇪🇨',
  ky: '🇰🇾',
  mt: '🇲🇹',
  us: '🇺🇸',
  rw: '🇷🇼',
  es: '🇪🇸',
  as: '🇦🇸',
  mm: '🇲🇲',
  pe: '🇵🇪',
  tc: '🇹🇨',
  im: '🇮🇲',
  tn: '🇹🇳',
  gh: '🇬🇭',
  is: '🇮🇸',
  jm: '🇯🇲',
  ai: '🇦🇮',
  ba: '🇧🇦',
  gq: '🇬🇶',
  km: '🇰🇲',
  sc: '🇸🇨',
  zw: '🇿🇼',
  cy: '🇨🇾',
  bw: '🇧🇼',
  id: '🇮🇩',
  mo: '🇲🇴',
  se: '🇸🇪',
  mp: '🇲🇵',
  in: '🇮🇳',
  iq: '🇮🇶',
  tt: '🇹🇹',
  bz: '🇧🇿',
  ke: '🇰🇪',
  pn: '🇵🇳',
  mn: '🇲🇳',
  gt: '🇬🇹',
  ge: '🇬🇪',
  pg: '🇵🇬',
  lt: '🇱🇹',
  tj: '🇹🇯',
  py: '🇵🇾',
  cz: '🇨🇿',
  ar: '🇦🇷',
  pt: '🇵🇹',
  bd: '🇧🇩',
  kn: '🇰🇳',
  ps: '🇵🇸',
  uk: '🇬🇧',
  br: '🇧🇷',
  ga: '🇬🇦',
  ir: '🇮🇷',
  no: '🇳🇴',
  bj: '🇧🇯',
  gn: '🇬🇳',
  uz: '🇺🇿',
  ua: '🇺🇦',
  fk: '🇫🇰',
  sx: '🇸🇽',
  me: '🇲🇪',
  bh: '🇧🇭',
  ni: '🇳🇮',
  so: '🇸🇴',
  bb: '🇧🇧',
  hr: '🇭🇷',
  qa: '🇶🇦',
  bs: '🇧🇸',
  mz: '🇲🇿',
  cg: '🇨🇬',
  ws: '🇼🇸',
  cr: '🇨🇷',
  ve: '🇻🇪',
  lk: '🇱🇰',
  dz: '🇩🇿',
  vg: '🇻🇬',
  sm: '🇸🇲',
  kg: '🇰🇬',
  bf: '🇧🇫',
  it: '🇮🇹',
  mq: '🇲🇶',
  aw: '🇦🇼',
  er: '🇪🇷',
  co: '🇨🇴',
  et: '🇪🇹',
  dk: '🇩🇰',
  cv: '🇨🇻',
  am: '🇦🇲',
  tg: '🇹🇬',
  'us-ca': '🇺🇸', // Special case for California, mapped to the US flag
  np: '🇳🇵',
  zn: '🇿🇦',
  th: '🇹🇭',
  pl: '🇵🇱',
  fi: '🇫🇮',
  zm: '🇿🇲',
  il: '🇮🇱',
  td: '🇹🇩',
  tm: '🇹🇲',
  ee: '🇪🇪',
  ck: '🇨🇰',
  sl: '🇸🇱',
  ph: '🇵🇭',
  pr: '🇵🇷',
  pw: '🇵🇼',
  sv: '🇸🇻',
  na: '🇳🇦',
  af: '🇦🇫',
  mc: '🇲🇨',
  bl: '🇧🇱',
  ml: '🇲🇱',
  ls: '🇱🇸',
  cu: '🇨🇺',
  ht: '🇭🇹',
  ne: '🇳🇪',
  cc: '🇨🇨',
  fo: '🇫🇴',
  ss: '🇸🇸',
  kr: '🇰🇷',
  do: '🇩🇴',
  cd: '🇨🇩',
  ru: '🇷🇺',
  ch: '🇨🇭',
  uy: '🇺🇾',
  vi: '🇻🇮',
  hk: '🇭🇰',
  ca: '🇨🇦',
  sr: '🇸🇷',
  jp: '🇯🇵',
  bn: '🇧🇳',
  ng: '🇳🇬',
  fm: '🇫🇲',
  st: '🇸🇹',
  bq: '🇧🇶',
  sg: '🇸🇬',
  cm: '🇨🇲',
  ie: '🇮🇪',
  la: '🇱🇦',
  bg: '🇧🇬',
  lv: '🇱🇻',
  dm: '🇩🇲',
  sy: '🇸🇾',
  mh: '🇲🇭',
  lc: '🇱🇨',
  je: '🇯🇪',
  vn: '🇻🇳',
  ax: '🇦🇽',
  bo: '🇧🇴',
  mu: '🇲🇺',
  de: '🇩🇪',
  va: '🇻🇦',
  pf: '🇵🇫',
  om: '🇴🇲',
  fj: '🇫🇯',
  ms: '🇲🇸',
  nr: '🇳🇷',
  pa: '🇵🇦',
  nz: '🇳🇿',
  ug: '🇺🇬',
  ad: '🇦🇩',
  be: '🇧🇪',
  vc: '🇻🇨',
  sn: '🇸🇳',
  hu: '🇭🇺',
  tz: '🇹🇿',
  gl: '🇬🇱',
  lr: '🇱🇷',
  ag: '🇦🇬',
  tw: '🇹🇼',
  ao: '🇦🇴',
  cn: '🇨🇳',
  cf: '🇨🇫',
  gi: '🇬🇮',
  si: '🇸🇮',
  tl: '🇹🇱',
  mk: '🇲🇰',
  eg: '🇪🇬',
  cw: '🇨🇼',
  ly: '🇱🇾',
  tr: '🇹🇷',
  kp: '🇰🇵',
  gu: '🇬🇺',
  dj: '🇩🇯',
  mg: '🇲🇬',
  ae: '🇦🇪',
  gr: '🇬🇷',
  ma: '🇲🇦',
  gw: '🇬🇼',
  pk: '🇵🇰',
  gb: '🇬🇧',
  kz: '🇰🇿',
  jo: '🇯🇴',
  cx: '🇨🇽',
  sk: '🇸🇰',
  gm: '🇬🇲',
  sd: '🇸🇩',
  lu: '🇱🇺',
  au: '🇦🇺',
  mx: '🇲🇽',
  al: '🇦🇱',
  bi: '🇧🇮',
  li: '🇱🇮',
  hn: '🇭🇳',
  vu: '🇻🇺',
  ro: '🇷🇴',
  at: '🇦🇹',
  by: '🇧🇾',
  eh: '🇪🇭',
  to: '🇹🇴',
  mr: '🇲🇷',
  ci: '🇨🇮',
  nu: '🇳🇺',
  mv: '🇲🇻',
  my: '🇲🇾',
  za: '🇿🇦',
  md: '🇲🇩',
  kh: '🇰🇭',
  nf: '🇳🇫',
  nl: '🇳🇱',
  io: '🇮🇴',
  fr: '🇫🇷',
  kw: '🇰🇼',
  bm: '🇧🇲',
  gd: '🇬🇩',
  lb: '🇱🇧',
  rs: '🇷🇸',
  mw: '🇲🇼',
  gg: '🇬🇬',
  tk: '🇹🇰',
}

export const LocaleToTrendhimDomain: Record<string, string> = {
  'ar-AE': 'www.trendhim.ae',
  'bg-BG': 'www.trendhim.bg',
  'cs-CZ': 'www.trendhim.cz',
  'da-DK': 'www.trendhim.dk',
  'de-AT': 'www.trendhim.at',
  'de-CH': 'www.trendhim.ch',
  'de-DE': 'www.trendhim.de',
  'el-GR': 'www.trendhim.gr',
  'en-AE': 'www.trendhim.ae',
  'en-AU': 'www.trendhim.com.au',
  'en-CA': 'www.trendhim.ca',
  'en-GB': 'www.trendhim.co.uk',
  'en-IE': 'www.trendhim.ie',
  'en-NZ': 'www.trendhim.co.nz',
  'en-SG': 'www.trendhim.sg',
  'en-US': 'www.trendhim.com',
  'en-ZA': 'www.trendhim.co.za',
  'es-ES': 'www.trendhim.es',
  'es-US': 'www.trendhim.com',
  'fi-FI': 'www.trendhim.fi',
  'fr-BE': 'www.trendhim.be',
  'fr-CA': 'www.trendhim.ca',
  'fr-CH': 'www.trendhim.ch',
  'fr-FR': 'www.trendhim.fr',
  'hu-HU': 'www.trendhim.hu',
  'it-IT': 'www.trendhim.it',
  'nb-NO': 'www.trendhim.no',
  'nl-BE': 'www.trendhim.be',
  'nl-NL': 'www.trendhim.nl',
  'pl-PL': 'www.trendhim.pl',
  'pt-PT': 'www.trendhim.pt',
  'ro-RO': 'www.trendhim.ro',
  'ru-RU': 'www.trendhim.ru',
  'sk-SK': 'www.trendhim.sk',
  'sv-SE': 'www.trendhim.se',
}
